<template>
  <div>
    <Card>

      <Row class="search-con">
        <Col span="24">
          <label class="search-label">开始时间</label>
          <Date-picker
            :value="startTime"
            @on-change="startTime = $event"
            type="datetime"
            placeholder="选择开始时间"
            style="width: 170px"
          ></Date-picker>
          <label class="search-label">结束时间</label>
          <Date-picker
            :value="endTime"
            @on-change="endTime = $event"
            type="datetime"
            placeholder="选择结束时间"
            style="width: 170px"
          ></Date-picker>

          <Input
            clearable
            placeholder="输入关键字搜索"
            class="search-input"
            v-model="keyword"
          />
          <label class="search-label" >平台</label>
          <Select v-model="live" class="search-input"  @on-change="liveTypeChange" clearable> 
            <Option
              v-for="item in liveIds"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>

          <label class="search-label">用户</label>
          <Select v-model="user" class="search-input" clearable filterable>
            <Option
              v-for="item in userIds"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>

          <Button @click="handleSearch" class="search-btn" type="primary"
            >搜索</Button
          >
        </Col>
      </Row>

      <tables
        editable
        :columns="columns"
        v-model="tableData"
        :loading="tableLoading"
      />
      <Row class="page-con">
        <div class="page-bottom">
          <Page
            :current="page"
            :total="total"
            :page-size="pageSize"
            :page-size-opts="[10, 20, 30, 40, 100]"
            show-sizer
            show-elevator
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </Row>
    </Card>
  </div>
</template>

<script>
import Tables from "_c/tables/table-only.vue";
import { listComment,getLiveType, getStrategyUser} from "@/api/data";
export default {
  name: "finance",
  components: {
    Tables
  },
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 10,
      addModal: false,
      editModal: false,
      resetFlag: false,
      editData: {},
      tableLoading: true,
      startTime: "",
      endTime: "",
      keyword:'',
      live:"",
      user:'',
      type:'',
      userIds:[],
      liveIds:[],
      types:[{
        id:2,
        name:'点赞'
      },{
        id:1,
        name:'评论'
      },{
        id:0,
        name:'浏览'
      }],
      columns: [
        {type: 'index', title: '序号',width: 70, align: "center"},
        { title: "谁的视频" , key: "username", editable: true, align: "center" },
        // {title: "类型", key: "type", align: "center",
        //   render: (h, params) => {
        //     let type = params.row.type;
        //     var texts = "浏览"
        //     if (type == 1){
        //       texts = "评论"
        //     }else if (type == 2){
        //       texts = "点赞"
        //     }
        //     return h(
        //       "div",
        //       {
        //         props: {},
        //       },
        //       texts
        //     );
        //   },
        // },
        { title: "视频标题" , key: "video_title", editable: true, align: "center",
        render: (h, params) => {
              return h('div', [
              // 显示的位置上方
                h('Tooltip', {
                  props: { placement: 'top' ,transfer: true}
                }, [
                  h('span', {
                    style: {
                      display: 'inline-block',
                      width: '70px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    },
                  }, params.row.video_title),
                  // 显示的内容
                  h('span', {
                    slot: 'content',
                    style: { whiteSpace: 'normal', wordBreak: 'break-all' }
                  },params.row.video_title)
                ])
              ])
        }},
        { title: "评论内容" , key: "content", editable: true , align: "center" },
        { title: "是谁去操作的" , key: "dy_source_name", editable: true , align: "center"},
        { title: "视频链接" , key: "video_url", editable: true , align: "center",
        render: (h, params) => {
            return params.row.video_url != '' ? h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.download(params.row.video_url);
                    },
                  },
                },
                "查看"
              )
            ]) : h('span', '');
          }
        },
        { title: "被点赞数" , key: "like_count", editable: true , align: "center", sortable: true}, 
        { title: "回复数" , key: "comment_count", editable: true , align: "center", sortable: true}, 
        { title: "评论时间" , key: "create_time", editable: true , align: "center"},
        { title: "更新时间" , key: "update_time", editable: true , align: "center"},
        {
        title: "Handle",
        key: "handle",
        render: (h, params) => {
          return h("div", [
            h(
              "Button",
              {
                props: {
                  type: "text",
                  size: "small",
                },
                style: {
                  marginRight: "5px",
                },
                on: {
                  click: () => {
                    this.seeChildrenComment(params);
                  },
                },
              },
              "查看子评论"
            )
          ]);
        },
        }
      ],
      tableData: [],
    };
  },
  methods: {
    download(url) {
      window.open(url, '_blank');
    },
    seeChildrenComment(params){
      if (params.row.comment_count != 0){
        this.$router.push({ name: "children_comment", query: { id: params.row.id}});
      }else{
        this.$Message.error("没有子评论!");
      }
      
    },
    cancel() {},
    changePage(page) {
      this.page = page;
      this.handleSearch();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.handleSearch();
    },
    liveTypeChange(value){
      if (value == undefined){
        return
      }
      this.live_id = value
      this.getStrategyUserData()
      
    } ,getStrategyUserData(){
      var params_ = {
        live_id: this.live_id
      }
      getStrategyUser(params_).then((res) => {
        var users = res.data.data.records;
        var data = new Array()
        for (var i = 0; i < users.length; i++) {
          data[i] = { id: users[i].dy_id, name: users[i].username }
      }
        this.userIds = data
      });
    },
    handleSearch() {
      this.setTableLoading(true);
      let params = {
        page: this.page,
        pageSize: this.pageSize,
        live_id: this.live,
        type: this.type,
        dy_id: this.user,
        startTime: this.startTime,
        endTime: this.endTime,
        keyword: this.keyword
      };
      listComment(params).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        
        this.setTableLoading(false);
      });

      getLiveType(params).then((res) => {
        if (res.data.code == 200) {
          var lives = res.data.data;
          var data = new Array()
          for (var i = 0; i < lives.length; i++) {
            data[i] = { id: lives[i].id.toString(), name: lives[i].name }
          }
          this.liveIds = data
          }
      });      
    },
    setTableLoading(state) {
      this.tableLoading = state;
    },
  },
  mounted() {
    this.handleSearch();
  },
};
</script>
